import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Container,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/material";

import moment from "moment";
import EventCard from "../layout/EventCard";
import { getData, getDistance } from "./UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { AuthContext } from "../user/BCPAuthProvider";
import ListMap from "../other/ListMap";
import { ActiveEventsModal } from "../../pages/organize/EventsOrganize/EventsOrganizeDefault";
const IS_BCP = getEnvironmentVariable("IS_BCP") === "true";

const searchLimit = 100;

export default function HighlightedEvents() {
  const [events, setEvents] = useState(null);
  const [geoLocation, setGeoLocation] = useState(null);
  const [activeEvents, setActiveEvents] = useState(null);

  const authContext = useContext(AuthContext);

  const getEvents = async () => {
    const queryStringParameters = {
      limit: searchLimit,
      startDate: `${moment()
        .subtract(1, "day")
        .format("YYYY-MM-DD")}T00:00:00Z`,
      endDate: `${moment().add(1, "week").format("YYYY-MM-DD")}T00:00:00Z`,
      "expand[]": ["gameSystem", "photoFile"],
    };
    if (IS_BCP) {
      queryStringParameters.pricingDict = true;
    } else {
      queryStringParameters.ticketPrice = 1;
    }
    if (getEnvironmentVariable("SINGLE_GAME_SYSTEM")) {
      queryStringParameters.gameSystemId =
        getEnvironmentVariable("SINGLE_GAME_SYSTEM");
    } else if (getEnvironmentVariable("SINGLE_GAME_TYPE")) {
      queryStringParameters.gameType =
        getEnvironmentVariable("SINGLE_GAME_TYPE");
    } else if (getEnvironmentVariable("SINGLE_GAME_MANUFACTURER")) {
      queryStringParameters.gameSystemManufacturer = getEnvironmentVariable(
        "SINGLE_GAME_MANUFACTURER"
      );
    }
    var apiGetData = await getData("/events", {
      queryStringParameters: queryStringParameters,
    });

    if (apiGetData?.data?.length) {
      apiGetData.data.forEach((event) => {
        event.random = Math.random();
        if (event.coordinate && event.coordinate.length >= 2) {
          event.distance = getDistance(
            event.coordinate[1],
            event.coordinate[0],
            geoLocation
          );
        } else {
          event.distance = 9999;
        }

        if (event.pricingDict) {
          var keys = Object.keys(event.pricingDict);
          if (keys.length > 0) {
            event.pricingInfo = {
              currency: keys[0],
              amount: (event.pricingDict[keys[0]] / 100).toFixed(2),
            };
          }
        }
      });

      apiGetData.data.sort((a, b) => {
        if (a.distance === b.distance) {
          return a.random - b.random;
        } else {
          return a.distance - b.distance;
        }
      });

      return apiGetData.data.slice(0, 12);
    }

    return apiGetData.data;
  };

  useEffect(() => {
    const check = async () => {
      try {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(function (position) {
            setGeoLocation(position.coords);
          });
        }
        var apiEvents = await getEvents();
        if (apiEvents) {
          setEvents(apiEvents);
        } else {
          setEvents([]);
        }
      } catch (err) {
        setEvents([]);
      }
    };
    check();
    // eslint-disable-next-line
  }, []);

  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Grid container spacing={1} sx={{ p: 1, mb: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h3" sx={{ fontWeight: 700 }} gutterBottom>
            Highlighted Events
          </Typography>
        </Grid>

        {!events ? (
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        ) : (
          <>
            {events && events.length > 0 && (
              <Grid item xs={12}>
                <ListMap
                  name="events-map"
                  originalList={
                    events
                      ? events?.filter((event) => !event?.isOnlineEvent)
                      : []
                  }
                  zoom={9}
                  sx={{ mb: 1 }}
                  mapSx={{ height: "30vh" }}
                  defaultCenter={
                    events?.length
                      ? {
                          lat: events?.[0]?.coordinate?.[1],
                          lng: events?.[0]?.coordinate?.[0],
                        }
                      : null
                  }
                  onClick={(lat, lng) => {
                    const eventArr = [];
                    events.forEach((event) => {
                      if (
                        event?.coordinate[0] === lng &&
                        event?.coordinate[1] === lat
                      ) {
                        eventArr.push(event);
                      }
                    });

                    setActiveEvents(eventArr);
                  }}
                  filterFunction={(event) =>
                    !event?.isOnlineEvent &&
                    (event?.coordinate?.length ||
                      event?.coordinate_point?.coordinates?.length) &&
                    (event?.coordinate[0] ||
                      event?.coordinate_point?.coordinates[0]) &&
                    (event?.coordinate[1] ||
                      event?.coordinate_point?.coordinates[1])
                  }
                />
              </Grid>
            )}

            {events &&
              events.length > 0 &&
              events.map((event, index) => {
                return (
                  <Grid key={index} item xs={12} sm={6} md={4}>
                    <EventCard
                      event={event}
                      key={index}
                      authContext={authContext}
                    />
                  </Grid>
                );
              })}
          </>
        )}
        {events && (
          <Grid item xs={12} textAlign="center">
            <Button
              href="/events"
              variant={
                getEnvironmentVariable("COMPANY_FLAG") === "catan"
                  ? "contained"
                  : "outlined"
              }
              color="primary"
            >
              {events?.length > 0 ? "See More" : "Find an Event"}
            </Button>
          </Grid>
        )}

        {activeEvents?.length && (
          <ActiveEventsModal
            activeEvents={activeEvents}
            setActiveEvents={setActiveEvents}
          />
        )}
      </Grid>
    </Container>
  );
}
